import React, { useState } from "react";
import { registerObj } from "../services/register-services";
import RegisterComponent from "../components/RegisterComponent";
import styles from "../styles/register.module.css";

function Register() {
  

  return (
    <div style={{width: "100%"}}>
      <RegisterComponent />
    </div>
  );
}
export default Register;
